<template>
    <div class="flex justify-content-center align-items-center px-3">
        <Dropdown v-model="selectedNumber" :options="screenCounts" placeholder="Select a Number"
            class="w-full md:w-24rem mt-8" />
    </div>
</template>

<script setup>
import { ref, watch, defineEmits } from 'vue';

const emit = defineEmits(['selected']);
const screenCounts = ref([1, 2, 3]);
const selectedNumber = ref();

watch(selectedNumber, (number) => emit('selected', number));
</script>

<style>
/* Add your CSS styles here */
</style>